import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../request';
import 'bootstrap/dist/css/bootstrap.min.css';
import { URL } from '../api'; 


const DisbursementView = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loanId = queryParams.get('loanId');
  const customerId = queryParams.get('customerId');

  const [customer, setCustomer] = useState({});
  const [loan, setLoan] = useState({});
  const [disbursal, setDisbursal] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loanId && customerId) {
      fetchData();
    }
  }, [loanId, customerId]);

  const fetchData = async () => {
  setLoading(true);
  try {
    const res = await axiosInstance.get(URL.DISBURSAL_VIEW, {
  params: { customerId, loanId },
});
    setCustomer(res.data.customer || {});
    setLoan(res.data.loan || {});
    setDisbursal(res.data.disbursal || {});
  } catch (error) {
    console.error("Error fetching disbursal view", error);
  } finally {
    setLoading(false);
  }
};

  if (loading) {
    return <div className="container mt-4">Loading disbursement details...</div>;
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Loan Disbursement Summary</h3>

     {/* Customer Info */}
<div className="card mb-4 shadow-sm">
  <div className="card-header bg-primary text-white">Customer Information</div>
  <div className="card-body row g-3">
    <div className="col-md-6"><strong>Full Name:</strong> {customer.full_name || '-'}</div>
    <div className="col-md-6"><strong>Father's Name:</strong> {customer.father_name || '-'}</div>
    <div className="col-md-6"><strong>Spouse Name:</strong> {customer.spouse_name || '-'}</div>
    <div className="col-md-6"><strong>Date of Birth:</strong> {customer.date_of_birth || '-'}</div>
    <div className="col-md-6"><strong>Gender:</strong> {customer.gender || '-'}</div>
    <div className="col-md-6"><strong>Marital Status:</strong> {customer.marital_status || '-'}</div>
    <div className="col-md-6"><strong>Phone Number:</strong> {customer.phone_number || '-'}</div>
    <div className="col-md-6"><strong>Email:</strong> {customer.email || '-'}</div>
    <div className="col-md-6"><strong>Aadhaar Number:</strong> {customer.aadhaar_number || '-'}</div>
    <div className="col-md-6"><strong>PAN Number:</strong> {customer.pan_number || '-'}</div>
    <div className="col-md-6"><strong>PIN Code:</strong> {customer.pin_code || '-'}</div>
    <div className="col-md-6"><strong>Occupation:</strong> {customer.occupation || '-'}</div>
    <div className="col-md-12"><strong>Address:</strong> {customer.address || '-'}</div>
    <div className="col-md-6"><strong>Status:</strong> {customer.status || '-'}</div>
    <div className="col-md-6"><strong>Created Date:</strong> {customer.created_date || '-'}</div>
    <div className="col-md-6"><strong>Updated Date:</strong> {customer.update_date || '-'}</div>
  </div>
</div>

     {/* Loan Info Card */}
<div className="card mb-4 shadow-sm">
  <div className="card-header bg-dark text-white">Loan Summary</div>
  <div className="card-body row g-3">

    <div className="col-md-6">
      <label><strong>Loan ID</strong></label>
      <input className="form-control" disabled value={`${loan.id || ''}`} />
    </div>

    <div className="col-md-6">
      <label><strong>Customer ID</strong></label>
      <input className="form-control" disabled value={loan.customer_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Loan Type</strong></label>
     <input
  className="form-control"
  disabled
  value={
    loan.amount && loan.tenure
      ? `${Math.round(loan.amount / 1000)}K${loan.tenure}`
      : (loan.product_name || '')
  }
/>

    </div>

    <div className="col-md-6">
      <label><strong>Product ID</strong></label>
      <input className="form-control" disabled value={loan.product_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Loan Amount</strong></label>
      <input className="form-control" disabled value={`₹${loan.amount?.toLocaleString() || '0'}`} />
    </div>

    <div className="col-md-6">
      <label><strong>Disbursed Amount</strong></label>
      <input className="form-control" disabled value={`₹${loan.disbursed_amount?.toLocaleString() || '0'}`} />
    </div>

    <div className="col-md-6">
      <label><strong>Interest Rate (ROI)</strong></label>
      <input className="form-control" disabled value={`${loan.roi || 0}%`} />
    </div>

    <div className="col-md-6">
      <label><strong>APR</strong></label>
      <input className="form-control" disabled value={`${loan.apr || 0}%`} />
    </div>

    <div className="col-md-6">
      <label><strong>ROI Type</strong></label>
      <input className="form-control" disabled value={loan.roi_type || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Tenure</strong></label>
      <input className="form-control" disabled value={`${loan.tenure || 0} days`} />
    </div>

    <div className="col-md-6">
      <label><strong>Number of EMI</strong></label>
      <input className="form-control" disabled value={loan.number_of_emi || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>EMI Amount</strong></label>
      <input className="form-control" disabled value={`₹${loan.emi_amount?.toLocaleString() || '0'}`} />
    </div>

    <div className="col-md-6">
      <label><strong>EMI Date</strong></label>
      <input className="form-control" disabled value={loan.emi_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Repayment Type</strong></label>
      <input className="form-control" disabled value={loan.repayment_type || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>UMRN Number</strong></label>
      <input className="form-control" disabled value={loan.umrn_number || ''} />
    </div>

    

    <div className="col-md-6">
      <label><strong>Processing Fee</strong></label>
      <input className="form-control" disabled value={`₹${loan.processing_fee?.toLocaleString() || '0'}`} />
    </div>

    {/* <div className="col-md-6">
      <label><strong>Processing Fee Charge</strong></label>
      <input className="form-control" disabled value={`₹${loan.processing_fee_charge?.toLocaleString() || '0'}`} />
    </div> */}


    <div className="col-md-6">
      <label><strong>Approved Date</strong></label>
      <input className="form-control" disabled value={loan.approved_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Disbursed Date</strong></label>
      <input className="form-control" disabled value={loan.disbursed_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Close Date</strong></label>
      <input className="form-control" disabled value={loan.close_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Status</strong></label>
      <input
        className={`form-control fw-bold text-white ${loan.status === 2 ? "bg-success" : "bg-secondary"}`}
        disabled
        value={loan.status === 2 ? "Approved" : loan.status}
      />
    </div>

   

    <div className="col-md-6">
      <label><strong>Create Date</strong></label>
      <input className="form-control" disabled value={loan.create_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Update Date</strong></label>
      <input className="form-control" disabled value={loan.update_date || ''} />
    </div>

    <div className="col-md-6">
  <label><strong>Total GST</strong></label>
  <input
    className="form-control fw-bold"
    disabled
    value={`₹${loan.total_gst?.toLocaleString() || '0'}`}
  />
</div>

  </div>
</div>


      {/* Disbursement Details Card */}
<div className="card mb-4 shadow-sm">
  <div className="card-header bg-success text-white">Disbursement Details</div>
  <div className="card-body row g-3">

    <div className="col-md-6">
      <label><strong>Disbursement ID</strong></label>
      <input className="form-control" disabled value={disbursal.id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Payout ID</strong></label>
      <input className="form-control" disabled value={disbursal.payout_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Loan ID</strong></label>
      <input className="form-control" disabled value={disbursal.loan_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Customer ID</strong></label>
      <input className="form-control" disabled value={disbursal.customer_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Approved Amount</strong></label>
      <input className="form-control" disabled value={`₹${disbursal.approved_amt?.toLocaleString() || '0'}`} />
    </div>

    <div className="col-md-6">
      <label><strong>Disbursed Amount</strong></label>
      <input className="form-control" disabled value={`₹${disbursal.amt?.toLocaleString() || '0'}`} />
    </div>

    <div className="col-md-6">
      <label><strong>Status</strong></label>
      <input
        className={`form-control fw-bold text-white ${disbursal.status === "Approved" ? "bg-success" : "bg-secondary"}`}
        disabled
        value={disbursal.status || ''}
      />
    </div>

    <div className="col-md-6">
      <label><strong>Fund Account ID</strong></label>
      <input className="form-control" disabled value={disbursal.fund_account_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Contact ID</strong></label>
      <input className="form-control" disabled value={disbursal.contact_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Checker ID</strong></label>
      <input className="form-control" disabled value={disbursal.checker_id || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Checker Date</strong></label>
      <input className="form-control" disabled value={disbursal.checker_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Date</strong></label>
      <input className="form-control" disabled value={disbursal.date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Payout Reason</strong></label>
      <input className="form-control" disabled value={disbursal.failed_reason || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Create Date</strong></label>
      <input className="form-control" disabled value={disbursal.create_date || ''} />
    </div>

    <div className="col-md-6">
      <label><strong>Update Date</strong></label>
      <input className="form-control" disabled value={disbursal.update_date || ''} />
    </div>

  </div>
</div>
    </div>
  );
};

export default DisbursementView;
